export default function Divider({className}) {
    return (
        <hr className={`my-2 border-blue-gray-500  mx-1 ${className}`} />
    )
}